import { render, staticRenderFns } from "./Summary.vue?vue&type=template&id=61cf42ff&scoped=true"
import script from "./Summary.vue?vue&type=script&lang=js"
export * from "./Summary.vue?vue&type=script&lang=js"
import style0 from "./Summary.vue?vue&type=style&index=0&id=61cf42ff&prod&lang=scss&scoped=true"
import style1 from "./Summary.vue?vue&type=style&index=1&id=61cf42ff&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61cf42ff",
  null
  
)

export default component.exports